import { STORAGE_KEYS } from '../constants';

export function getOrCreateDeviceFingerprint(): string {
  if (typeof window === 'undefined') return '';
  let fingerprint = localStorage.getItem(STORAGE_KEYS.CASHIER_DEVICE_FINGERPRINT);
  if (!fingerprint) {
    fingerprint = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `fp-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(STORAGE_KEYS.CASHIER_DEVICE_FINGERPRINT, fingerprint);
  }
  return fingerprint;
}
